import { render } from "./Nfse.vue?vue&type=template&id=1fe1e354&scoped=true"
import script from "./Nfse.vue?vue&type=script&lang=js"
export * from "./Nfse.vue?vue&type=script&lang=js"

import "./Nfse.vue?vue&type=style&index=0&id=1fe1e354&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe1e354"]])

export default __exports__